import { render, staticRenderFns } from "./ManageCards.vue?vue&type=template&id=0fb6e55c&"
import script from "./ManageCards.vue?vue&type=script&lang=js&"
export * from "./ManageCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports